import React from 'react'
import PropTypes from 'prop-types'

let dataLayer

if (typeof window !== `undefined`) {
  dataLayer = window.dataLayer
}

const propTypes = {
  urlForm: PropTypes.string,
  formCategory: PropTypes.string,
  formType: PropTypes.string,
}

const FeedbackFormOptionButtons = props => {
  const { formCategory, urlForm, formType } = props
  //clean up the string by making it all lowercase
  const urlInitialCategoryString =
    '/help/form/contact-us/' + formCategory.replace(/\s+/g, '-').toLowerCase()
  //clean up the string further by also removing " and '"
  const urlCategoryString = urlInitialCategoryString.replace(/['"]+/g, '')

  const urlDefaultCategoryString = '/help/form/contact-us/'
  const urlFoodBoxCategoryString = '/help/form/contact-us/food-boxes'

  /* const urlCategoryString =
    '/help/form/contact-us/' + formCategory.replace(/\s+/g, '-').toLowerCase()*/
  /*const urlCategoryString = '/help/form/contact-us/'*/

  function intiateLiveChat() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({ event: 'livechat', action: '{{ActionType}}' })
    }
    //This Code references the main Live Chat code that sits in the static folder
    // eslint-disable-next-line no-undef
    initESW('https://service.force.com')
    ;(function(history) {
      history.pushState = function(state) {
        this.settings.targetElement.appendChild()
      }
    })(window.history)
  }

  return (
    <>
      {/* BOTTOM GREEN BAR FOR UNDEFINED FAQS */}
      {urlForm === undefined && (
        <section className="flex items-center justify-center w-full p-4 mt-6 bg-gradient-r-primary">
          {formCategory !== 'Morrisons Pick Up' &&
            formCategory !== 'Morrisons Alexa Skill' &&
            formCategory !== 'Coronavirus' &&
            formCategory !== 'Morrisons Food Boxes' && (
              <a
                href={urlCategoryString}
                className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
              >
                Email us
              </a>
            )}
          {formCategory === 'Morrisons Pick Up' && (
            <a
              href={urlDefaultCategoryString}
              className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
            >
              Email us.
            </a>
          )}
          {formCategory === 'Morrisons Alexa Skill' && (
            <a
              href={urlDefaultCategoryString}
              className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
            >
              Email us
            </a>
          )}
          {formCategory === 'Coronavirus' && (
            <a
              href={urlDefaultCategoryString}
              className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
            >
              Email us
            </a>
          )}
          {formCategory === 'Morrisons Food Boxes' && (
            <a
              href={urlFoodBoxCategoryString}
              className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
            >
              Email us
            </a>
          )}
          {/* <a
            href={'/help/call-us/'}
            className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
          >
            Call us
          </a> */}
        </section>
      )}
      {/* BOTTOM GREEN BAR FOR CALL */}
      {formType === 'callonly' && (
        <section className="flex items-center justify-center w-full p-4 mt-6 bg-gradient-r-primary">
          <a
            href={'/help/call-us/'}
            className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
          >
            Call us
          </a>
        </section>
      )}
      {formType === 'call' && (
        <section className="flex items-center justify-center w-full p-4 mt-6 bg-gradient-r-primary">
          <a
            href={'/help/call-us/'}
            className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
          >
            Call us
          </a>
        </section>
      )}
      {/* BOTTOM GREEN BAR FOR LIVE CHAT */}
      {formType === 'livechat' && null
      // <section className="flex items-center justify-center w-full p-4 mt-6 bg-gradient-r-primary">
      //   <button
      //     onClick={intiateLiveChat}
      //     className="px-4 py-2 mx-1 text-sm bg-white rounded-full outline-none transition-fast hover:opacity-50 focus:outline-none"
      //   >
      //     Live Chat
      //   </button>
      //   {/* <a
      //     href={'/help/call-us/'}
      //     className="px-4 py-2 mx-1 text-sm bg-white rounded-full transition-fast hover:opacity-50"
      //   >
      //     Call us
      //   </a> */}
      // </section>
      }
    </>
  )
}

FeedbackFormOptionButtons.propTypes = propTypes

export default FeedbackFormOptionButtons
